import { ErrorBoundary } from '@/components/Rollbar';
import { SuspenseLoading } from '@/components/SuspenseErrorBoundary/fallback';
import { SmartListViewDetails } from '@/features/admin_invoice_reports/components/AdminInvoiceReportDetailDrawer/Detail/LeftContent/ApplicationContent/components/SmartListViewDetails';
import { useAdminInvoiceReportPaymentInfoData } from '@/features/admin_invoice_reports/components/AdminInvoiceReportDetailDrawer/Detail/LeftContent/ApplicationContent/hooks/useAdminInvoiceReportPaymentInfoData';
import { useTranslation } from '@/i18n';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { FC, memo, Suspense, useEffect } from 'react';

type ApplicationDetailProps = {
  reportId: string;
};

type InnerListProps = {
  reportId: string;
};

type ErrorFallbackProps = {
  error: Error | null;
};

const InnerList: FC<InnerListProps> = memo(({ reportId }) => {
  const data = useAdminInvoiceReportPaymentInfoData(reportId);

  return <SmartListViewDetails data={data ?? { report_form_inputs: [] }} />;
});
InnerList.displayName = 'InnerList';

const ErrorFallback: FC<ErrorFallbackProps> = ({ error }) => {
  const { t } = useTranslation();
  const notify = useToastAPI();
  useEffect(() => {
    notify.error({
      title: error?.message ?? t('system_error'),
      duration: 3,
    });
  }, [error, notify, t]);
  return <></>;
};
ErrorFallback.displayName = 'ErrorFallback';

export const ApplicationDetail: FC<ApplicationDetailProps> = memo(
  ({ reportId }) => {
    return (
      <Suspense fallback={<SuspenseLoading />}>
        <ErrorBoundary
          fallback={({ error }) => <ErrorFallback error={error} />}
        >
          <InnerList reportId={reportId} />
        </ErrorBoundary>
      </Suspense>
    );
  }
);

ApplicationDetail.displayName = 'AdminInvoiceReportDetailApplicationDetail';
